import React from 'react'

const Col = ({cols = "col-md-6", children}) => {
    return (
        <div className={cols}>{children}</div>
    )
}

export default Col